import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readTotal: emisor =>
    api
      .send({
        query: gql`
          query readTotal($emisor: ID!) {
            Caja {
              readTotal(emisor: $emisor)
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Caja.readTotal),

  readAllByEmisor: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readAllByEmisor($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Caja {
              readAllByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  _id

                  userSession {
                    _id
                    fullname
                  }
                  name
                  status
                  state
                  limiteInferior
                  limiteSuperior
                  cuentaContable
                  createdAt
                  updatedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Caja.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: CajaInput!) {
            Caja {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Caja.create),

  // setStatus: (_id, status) =>
  //   api
  //     .send({
  //       query: gql`
  //         mutation SET_STATUS($_id: ID!, $status: CajaStatus!) {
  //           Caja {
  //             setStatus(_id: $_id, status: $status)
  //           }
  //         }
  //       `,
  //       variables: {
  //         _id,
  //         status
  //       }
  //     })
  //     .then(result => result.data.data.Caja.setStatus),

  readBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readBySearchString($emisor: ID!, $searchString: String!) {
            Caja {
              readBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  _id

                  userSession {
                    _id
                    fullname
                  }
                  name
                  status
                  state
                  createdAt
                  updatedAt
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Caja.readBySearchString),

  // readByStatus: (emisor, restaurant, status) =>
  //   api
  //     .send({
  //       query: gql`
  //         query readByStatus($emisor: ID!, $restaurant: ID!, $status: [String!]) {
  //           Caja {
  //             readByStatus(emisor: $emisor, restaurant: $restaurant, status: $status) {
  //               _id

  //               userSession {
  //                 _id
  //                 fullname
  //               }
  //               name
  //               status
  //               createdAt
  //               updatedAt
  //             }
  //           }
  //         }
  //       `,
  //       variables: {
  //         emisor,
  //         restaurant,
  //         status
  //       }
  //     })
  //     .then(result => result.data.data.Caja.readByStatus)

  readById: _id =>
    api
      .send({
        query: gql`
          query readById($_id: ID!) {
            Caja {
              readById(_id: $_id) {
                _id
                name
                status
                state
                limiteInferior
                limiteSuperior
                cuentaContable
                createdAt
                updatedAt
                userSession {
                  _id
                  fullname
                }
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.Caja.readById)
}
